import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

//Dashboard
const DashboardCampaign = lazy(() => import("../pages/DashboardCampaign"));
const AdvancedDashboard = lazy(() => import("../pages/AdvancedDashboard"));

//Crm Pages
const CrmContacts = lazy(() => import("../pages/Crm/CrmContacts"));
const Notifications = lazy(() => import("../pages/Notifications"));

//Campaign
const Campaigns = lazy(() => import("../pages/Campaign/index"));
const Posts = lazy(() => import("../pages/Campaign/Posts/index"));
const AllPosts = lazy(() => import("../pages/Campaign/Posts/newGenPosts"));
const Report = lazy(() => import("../pages/Campaign/Report/index"));

//News
const NewsList = lazy(() => import("../pages/News/index"));
const AllNews = lazy(() => import("../pages/News/Posts/index"));

//Election2024
const Election2024 = lazy(() => import("../pages/Election2024/index"));
const Election2024List = lazy(() => import("../pages/Election2024/List/index"));

// //Ecommerce Pages
const EcommerceSellers = lazy(() =>
  import("../pages/Ecommerce/EcommerceSellers/index")
);

//pages
const Maintenance = lazy(() =>
  import("../pages/Pages/Maintenance/Maintenance")
);
const ComingSoon = lazy(() =>
  import("../pages/Pages/ComingSoon/ComingSoon")
);

//login
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));

// User Profile
const UserProfile = lazy(() =>
  import("../pages/Authentication/user-profile")
);

const PrivacyPolicy = lazy(() => import("../pages/Pages/PrivacyPolicy"));
const TermsCondition = lazy(() => import("../pages/Pages/TermsCondition"));

const Inquiries = lazy(() => import("../pages/Inquiries"));

const authProtectedRoutes = [
  { path: "/inquiries", component: <Inquiries /> },
  { path: "/dashboard", component: <DashboardCampaign /> },
  { path: "/main", component: <AdvancedDashboard /> },
  { path: "/index", component: <DashboardCampaign /> },
  //path: "/projects", component: <EcommerceSellers /> },
  { path: "/campaigns", component: <Campaigns /> },
  { path: "/posts", component: <Posts /> },
  //{ path: "/posts", component: <AllPosts /> },

  { path: "/report", component: <Report /> },
  { path: "/newslist", component: <NewsList /> },
  { path: "/news", component: <AllNews /> },
  { path: "/election2024control", component: <Election2024 /> },
  { path: "/election2024list", component: <Election2024List /> },

  //Crm
  { path: "/users", component: <CrmContacts /> },

  //Notifications
  { path: "/notifications", component: <Notifications /> },

  //Pages
  { path: "/pages-privacy-policy", component: <PrivacyPolicy /> },
  { path: "/pages-term-conditions", component: <TermsCondition /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/campaigns" />,
  },
  { path: "*", component: <Navigate to="/campaigns" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },

  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
